import { ILibraryScene } from './../interfaces/index';
import { AxiosResponse } from 'axios';
import httpClient from './http';

export const getSceneByIdForCheck = (
  id: string
): Promise<AxiosResponse<ILibraryScene>> => httpClient.post(`/api/scene`, {id});
